/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_No_Team_DescInputs */

const en_team_no_team_desc = /** @type {(inputs: Team_No_Team_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create your team workspace to invite staff and assign roles with granular permissions.`)
};

const es_team_no_team_desc = /** @type {(inputs: Team_No_Team_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea tu espacio de trabajo de equipo para invitar a personal y asignar roles con permisos granulares.`)
};

const fr_team_no_team_desc = /** @type {(inputs: Team_No_Team_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créez votre espace de travail d'équipe pour inviter du personnel et attribuer des rôles avec des permissions granulaires.`)
};

const de_team_no_team_desc = /** @type {(inputs: Team_No_Team_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstelle deinen Team-Arbeitsbereich, um Personal einzuladen und Rollen mit detaillierten Berechtigungen zuzuweisen.`)
};

const id_team_no_team_desc = /** @type {(inputs: Team_No_Team_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buat ruang kerja tim Anda untuk mengundang staf dan menetapkan peran dengan izin mendetail.`)
};

/** @type {(inputs: Team_No_Team_DescInputs) => LocalizedString} */
const ja_team_no_team_desc = en_team_no_team_desc;

/** @type {(inputs: Team_No_Team_DescInputs) => LocalizedString} */
const zh_team_no_team_desc = en_team_no_team_desc;

/** @type {(inputs: Team_No_Team_DescInputs) => LocalizedString} */
const ar_team_no_team_desc = en_team_no_team_desc;

/** @type {(inputs: Team_No_Team_DescInputs) => LocalizedString} */
const it_team_no_team_desc = en_team_no_team_desc;

/** @type {(inputs: Team_No_Team_DescInputs) => LocalizedString} */
const ru_team_no_team_desc = en_team_no_team_desc;

/** @type {(inputs: Team_No_Team_DescInputs) => LocalizedString} */
const pt_team_no_team_desc = en_team_no_team_desc;

/** @type {(inputs: Team_No_Team_DescInputs) => LocalizedString} */
const ko_team_no_team_desc = en_team_no_team_desc;

/**
* | output |
* | --- |
* | "Create your team workspace to invite staff and assign roles with granular permissions." |
*
* @param {Team_No_Team_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const team_no_team_desc = /** @type {((inputs?: Team_No_Team_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_No_Team_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_team_no_team_desc(inputs)
	if (locale === "es") return es_team_no_team_desc(inputs)
	if (locale === "fr") return fr_team_no_team_desc(inputs)
	if (locale === "de") return de_team_no_team_desc(inputs)
	if (locale === "ja") return ja_team_no_team_desc(inputs)
	if (locale === "zh") return zh_team_no_team_desc(inputs)
	if (locale === "ar") return ar_team_no_team_desc(inputs)
	if (locale === "id") return id_team_no_team_desc(inputs)
	if (locale === "it") return it_team_no_team_desc(inputs)
	if (locale === "ru") return ru_team_no_team_desc(inputs)
	if (locale === "pt") return pt_team_no_team_desc(inputs)
	return ko_team_no_team_desc(inputs)
});